// @flow
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { getGeoOsmString } from '../../../utils/geoOsm/utils';
import styles from './styles';

type Props = {
  geoInfo: {
    geoOsm: ?Array<GeoOsm>,
    numVisibleItems: number,
  },
};

const { fewResultsHomesSnippetGeo } = defineMessages({
  fewResultsHomesSnippetGeo: {
    id: 'global_few_results_homes_snippet_geo',
    defaultMessage: "It's located in {%1$s}",
  },
});

function formattedLocation(geoInfo) {
  if (!geoInfo.geoOsm) {
    return null;
  }

  return getGeoOsmString(geoInfo.geoOsm, geoInfo.numVisibleItems);
}

function FewResultsHomesByLocationMessage({ geoInfo }: Props) {
  const location = formattedLocation(geoInfo);

  if (!location) {
    return null;
  }

  return (
    <div
      className="few-results-messages"
      itemScope={false} // Invalidate schema.org tags
      itemProp="address"
      itemType="http://schema.org/PostalAddress"
    >
      <span>
        <FormattedMessage
          {...fewResultsHomesSnippetGeo}
          values={{
            '%1$s': location,
          }}
        />
      </span>
      <style jsx>{styles}</style>
    </div>
  );
}

FewResultsHomesByLocationMessage.defaultProps = {
  city: null,
  address: null,
  area: null,
  region: null,
};

export default FewResultsHomesByLocationMessage;



// WEBPACK FOOTER //
// ./app/common/FewResultsMessages/homes/index.js